import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { APP_CONTENT_QUERY_KEYS } from '@/lib/constants/appContent';
import { AppContentApi } from './AppContentApi';
import { ListlistTypeId } from '@lib2/model/listlist/ListlistType';
import type { ListlistDto } from '@lib2/model/listlist/ListlistDto';

export function useAppContentListlists() {
  const { selectedCId } = useAuth();

  const query = useQuery({
    queryKey: APP_CONTENT_QUERY_KEYS.listlists(selectedCId ?? 0),
    queryFn: () => AppContentApi.getListlists(selectedCId!).then((r) => r.data),
    enabled: selectedCId != null,
    staleTime: 2 * 60_000,
    gcTime: 10 * 60_000,
  });

  const listlists: ListlistDto[] = query.data ?? [];

  // Derived: split by type, exclude soft-deleted
  const active = listlists.filter((ll) => !ll.llr.deleted);
  const contentGroups = active.filter(
    (ll) => ll.llr.listlistTypeId === ListlistTypeId.Root,
  );
  const categories = active.filter(
    (ll) => ll.llr.listlistTypeId === ListlistTypeId.Category,
  );
  const series = active.filter(
    (ll) => ll.llr.listlistTypeId === ListlistTypeId.Series,
  );

  return { listlists, contentGroups, categories, series, ...query };
}
